import { render, staticRenderFns } from "./AnimatedBar.vue?vue&type=template&id=2bbef27a&scoped=true&lang=html&"
import script from "./AnimatedBar.vue?vue&type=script&lang=js&"
export * from "./AnimatedBar.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedBar.vue?vue&type=style&index=0&id=2bbef27a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbef27a",
  null
  
)

export default component.exports